import styles from '@features/cms/components/categories/CategoryUSPBlock/CategoryUSPBlock.styles';
import { ICategoryUSPBlock } from '@features/cms/typescript';
import UniversalShoppingValues from '@features/productPreview/sections/UniversalShoppingValues/components/IconWithText/UniversalShoppingValues';
import { useResponsive } from '@features/responsive';
type PropsType = {
  data: ICategoryUSPBlock;
};
const CategoryUSPBlock = ({
  data
}: PropsType) => {
  const {
    code,
    background,
    marginTop,
    marginBottom,
    icons
  } = data;
  const {
    isNarrowerThanMobilelg
  } = useResponsive();
  if (icons.length === 0) return null;
  const notEmptyItems = icons.filter(singleItem => singleItem.title.length > 0);
  if (notEmptyItems.length === 0) return null;
  return <section id={code} sx={styles.sectionContainer(marginTop, marginBottom)} data-testid={code}>
      <div sx={styles.container(background, icons.length)} data-testid="CategoryUSPBlock-container">
        <UniversalShoppingValues data={icons} isNarrowerThanTablet={!!isNarrowerThanMobilelg} />
      </div>
    </section>;
};
export default CategoryUSPBlock;